export default "/images/vendor/flag-icon-css/flags/1x1/mr.svg?41a32059e9a8eb6f1ceb7ba7ff4fdde1";